import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";

import { TRACK_EVENT_CATEGORY_ROUTE_STOP } from "../constants";
import { setStopSequence, trackEvent } from "../model/actions";
import AppPropTypes from "../model/propTypes";

import LineIconSvg from "./LineIconSvg";
import RouteOtherDestinationIcon from "./RouteOtherDestinationIcon";

function RouteWingStop({ lineInfos }) {
  const { line, stopSequence } = lineInfos;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(setStopSequence(stopSequence));
    dispatch(
      trackEvent(
        TRACK_EVENT_CATEGORY_ROUTE_STOP,
        "selectWingTrain",
        `${stopSequence.longName || stopSequence.shortName} ${
          stopSequence.destination
        }`,
      ),
    );
  }, [dispatch, stopSequence]);
  return (
    <div
      className="rt-route-station"
      onClick={onClick}
      onKeyPress={(evt) => evt.which === 13 && onClick()}
      role="button"
      style={{
        alignItems: "center",
        display: "flex",
        width: "100%",
      }}
      tabIndex={0}
    >
      <div className="rt-route-times" />
      <div className="rt-route-icon" style={{ marginLeft: "22.5px" }}>
        <RouteOtherDestinationIcon color={line?.color} />
      </div>
      <div className="rt-route-stop-name">
        <span style={{ margin: "0 10px" }}>
          <LineIconSvg line={line} />
        </span>
        <span className="rt-route-wing-stop-name">
          {stopSequence.destination}
        </span>
      </div>
    </div>
  );
}

RouteWingStop.propTypes = {
  lineInfos: AppPropTypes.lineInfos.isRequired,
};

export default memo(RouteWingStop);
